import React, { useState } from "react";
import "./Register.css";

const Register = () => {
  // STATES FORMULAIRE
  const [fullname, setFullname] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");

  const [showPwd, setShowPwd] = useState(false);
  const [showConfirmPwd, setShowConfirmPwd] = useState(false);

  return (
    <div className="login-page-lgn">
      <div className="login-inner-lgn">
        {/* ========== COLONNE GAUCHE : FORMULAIRE ========== */}
        <div className="login-left-lgn">
          {/* Logo */}
          <div className="login-logo-row-lgn">
            <div className="login-logo-icon-lgn" />
            <span className="login-logo-text-lgn">Weltoc Company.</span>
          </div>

          {/* Formulaire centré */}
          <div className="login-card-lgn">
            <h1 className="login-title-lgn">Inscription sur Weltoc</h1>
            <p className="login-subtitle-lgn">Simple, Rapide et Efficace</p>

            {/* Divider */}
            <div className="login-divider-lgn">
              <span className="login-divider-line-lgn" />
              <span className="login-divider-text-lgn">
                Créez votre compte en quelques secondes
              </span>
              <span className="login-divider-line-lgn" />
            </div>

            {/* -------- FULL NAME -------- */}
            <div className="login-field-lgn">
              <label className="login-label-lgn" >Nom & Prénoms</label><br />
              <input
                type="text"
                placeholder="Ex : Dupont Jean"
                className="login-input-lgn"
                value={fullname}
                onChange={(e) => setFullname(e.target.value)}
              />
            </div>

            {/* -------- PHONE -------- */}
            <div className="login-field-lgn">
              <label className="login-label-lgn">Numéro de téléphone</label>
              <input
                type="tel"
                placeholder="Ex : 0777888999"
                className="login-input-lgn"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>

            {/* -------- EMAIL -------- */}
            <div className="login-field-lgn">
              <label className="login-label-lgn">Adresse Email</label>
              <input
                type="email"
                placeholder="exemple@mail.com"
                className="login-input-lgn"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            {/* -------- PASSWORD -------- */}
            <div className="login-field-lgn">
              <label className="login-label-lgn">Mot de passe</label>

              <div className="login-password-wrap-lgn">
                <input
                  type={showPwd ? "text" : "password"}
                  placeholder="••••••••"
                  className="login-input-lgn login-input-password-lgn"
                  value={pwd}
                  onChange={(e) => setPwd(e.target.value)}
                />

                <button
                  type="button"
                  className="login-eye-btn-lgn"
                  onClick={() => setShowPwd(!showPwd)}
                >
                  {showPwd ? "🙈" : "👁"}
                </button>
              </div>
            </div>

            {/* -------- CONFIRM PASSWORD -------- */}
            <div className="login-field-lgn">
              <label className="login-label-lgn">Confirmez le mot de passe</label>

              <div className="login-password-wrap-lgn">
                <input
                  type={showConfirmPwd ? "text" : "password"}
                  placeholder="••••••••"
                  className="login-input-lgn login-input-password-lgn"
                  value={confirmPwd}
                  onChange={(e) => setConfirmPwd(e.target.value)}
                />

                <button
                  type="button"
                  className="login-eye-btn-lgn"
                  onClick={() => setShowConfirmPwd(!showConfirmPwd)}
                >
                  {showConfirmPwd ? "🙈" : "👁"}
                </button>
              </div>
            </div>

            {/* -------- OPTIONS -------- */}
            <div className="login-options-row-lgn">
              <label className="login-remember-lgn">
                <input type="checkbox" />
                <span>J'accepte les Termes & Conditions.</span>
              </label>

              <button className="login-link-btn-lgn">
                Mot de passe oublié ?
              </button>
            </div>

            {/* -------- BUTTON -------- */}
            <button className="login-submit-btn-lgn">S’inscrire</button>

            <p className="login-footer-text-lgn">
              Vous avez déjà un compte ?{" "}
              <button className="login-link-btn-lgn">Connectez-vous</button>
            </p>
          </div>

          {/* Bas de page */}
          <div className="login-bottom-row-lgn">
            <span>Privacy Policy</span>
            <span>Copyright 2026</span>
          </div>
        </div>

        {/* ========== COLONNE DROITE BLEUE ========== */}
        <div className="login-right-lgn">
          <div className="login-right-inner-lgn">
            {/* Carte blanche */}
            <div className="login-card-image-lgn">
                <img
                    src="/user.gif"   // ← mets ici ton image réelle
                    alt="Send Money Preview"
                    className="login-card-img-lgn"
                />
                </div>


            {/* Texte de droite */}
            <div className="login-right-text-lgn">
              <h2 className="login-right-title-lgn">Get better with money</h2>
              <p className="login-right-desc-lgn">
                Overpay helps you set saving goals, earn cash back offers. Go to
                disclaimer for more details and get paychecks up to two days
                early. Get a $20 bonus when you receive qualifying direct
                deposits.
              </p>

              <div className="login-dots-lgn">
                <span className="login-dot-lgn active" />
                <span className="login-dot-lgn" />
                <span className="login-dot-lgn" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
